import React from 'react';
import SolutionRentalCompleteWrapper from 'components/SolutionRentalCompleteWrapper';

export default function SolutionRentalCompleteContainer() {
  return (
    <SolutionRentalCompleteWrapper />
  )
}
